<template>
  <div>
    <h4>Clone Client Result</h4>
    <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
      <router-link
        :to="{ name: 'ManageClients' }"
        class="d-inline"
        style="font-weight: normal;"
      >
        Clients
      </router-link>
      <p class="d-inline pl-1 pr-1">/</p>
      <router-link
        :to="{ name: 'cloneClientForm' }"
        class="d-inline"
        style="font-weight: normal;"
      >
        Clone Client
      </router-link>
      <p class="d-inline pl-1 pr-1">/</p>
      <router-link :to="{}" class="d-inline" style="font-weight: normal;">
        Result
      </router-link>
    </div>
    <hr />
    <div class="border p-2 rounded" v-if="result">
      <div class="form-group">
        <label for="" class="m-0" style="display: inline;">Client IDs: </label>
        <p style="display: inline;">
          <span v-for="(clientID, idx) in result.clientIDs" :key="clientID"
            >{{ clientID
            }}{{ idx + 1 === result.clientIDs.length ? "" : "," }}</span
          >
        </p>
      </div>

      <div class="form-group">
        <label for="" class="m-0" style="display: inline;">Username: </label>
        <p style="display: inline;">
          {{ result.username }}
        </p>
      </div>

      <div class="form-group">
        <label for="" class="m-0" style="display: inline;">Password: </label>
        <p style="display: inline;">
          {{ result.password }}
        </p>
      </div>

      <div class="form-group">
        <label for="" class="m-0" style="display: inline;">Message: </label>
        <p style="display: inline;">
          {{ result.message }}
        </p>
      </div>

      <div class="form-group">
        <label for="" class="m-0" style="display: inline;">User Token: </label>
        <p style="display: inline; word-break: break-all;">
          {{ result.userToken }}
        </p>

        <button
          class="btn btn-primary d-block mt-2"
          id="copyToClipboard"
          @click="copyToClipboard"
        >
          Copy
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cloneClientResult",
  data() {
    return {};
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard
        .writeText(`Username: ${this.result.username} \nPassword: ${this.result.password} \nAPI Token: ${this.result.userToken}
      `);
    },
  },
  computed: {
    result() {
      return this.$store.state.cloneClient.cloneClientData;
    },
  },
  created() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
